var map = {
	"./ar/build": 40,
	"./ar/build.ts": 40,
	"./ar/donate": 41,
	"./ar/donate.ts": 41,
	"./ar/downloads": 42,
	"./ar/downloads.ts": 42,
	"./ar/features": 43,
	"./ar/features.ts": 43,
	"./ar/feedback": 44,
	"./ar/feedback.ts": 44,
	"./ar/general": 45,
	"./ar/general.ts": 45,
	"./ar/main": 46,
	"./ar/main.ts": 46,
	"./ar/menu": 47,
	"./ar/menu.ts": 47,
	"./ar/price": 48,
	"./ar/price.ts": 48,
	"./ar/roadmap": 49,
	"./ar/roadmap.ts": 49,
	"./de/build": 50,
	"./de/build.ts": 50,
	"./de/donate": 51,
	"./de/donate.ts": 51,
	"./de/downloads": 52,
	"./de/downloads.ts": 52,
	"./de/features": 53,
	"./de/features.ts": 53,
	"./de/feedback": 54,
	"./de/feedback.ts": 54,
	"./de/general": 55,
	"./de/general.ts": 55,
	"./de/main": 56,
	"./de/main.ts": 56,
	"./de/menu": 57,
	"./de/menu.ts": 57,
	"./de/price": 58,
	"./de/price.ts": 58,
	"./de/roadmap": 59,
	"./de/roadmap.ts": 59,
	"./en/build": 60,
	"./en/build.ts": 60,
	"./en/donate": 61,
	"./en/donate.ts": 61,
	"./en/downloads": 62,
	"./en/downloads.ts": 62,
	"./en/features": 63,
	"./en/features.ts": 63,
	"./en/feedback": 64,
	"./en/feedback.ts": 64,
	"./en/general": 65,
	"./en/general.ts": 65,
	"./en/main": 66,
	"./en/main.ts": 66,
	"./en/menu": 67,
	"./en/menu.ts": 67,
	"./en/price": 68,
	"./en/price.ts": 68,
	"./en/roadmap": 69,
	"./en/roadmap.ts": 69,
	"./es/build": 70,
	"./es/build.ts": 70,
	"./es/donate": 71,
	"./es/donate.ts": 71,
	"./es/downloads": 72,
	"./es/downloads.ts": 72,
	"./es/features": 73,
	"./es/features.ts": 73,
	"./es/feedback": 74,
	"./es/feedback.ts": 74,
	"./es/general": 75,
	"./es/general.ts": 75,
	"./es/main": 76,
	"./es/main.ts": 76,
	"./es/menu": 77,
	"./es/menu.ts": 77,
	"./es/price": 78,
	"./es/price.ts": 78,
	"./es/roadmap": 79,
	"./es/roadmap.ts": 79,
	"./fr/build": 80,
	"./fr/build.ts": 80,
	"./fr/donate": 81,
	"./fr/donate.ts": 81,
	"./fr/downloads": 82,
	"./fr/downloads.ts": 82,
	"./fr/features": 83,
	"./fr/features.ts": 83,
	"./fr/feedback": 84,
	"./fr/feedback.ts": 84,
	"./fr/general": 85,
	"./fr/general.ts": 85,
	"./fr/main": 86,
	"./fr/main.ts": 86,
	"./fr/menu": 87,
	"./fr/menu.ts": 87,
	"./fr/price": 88,
	"./fr/price.ts": 88,
	"./fr/roadmap": 89,
	"./fr/roadmap.ts": 89,
	"./hi/build": 90,
	"./hi/build.ts": 90,
	"./hi/donate": 91,
	"./hi/donate.ts": 91,
	"./hi/downloads": 92,
	"./hi/downloads.ts": 92,
	"./hi/features": 93,
	"./hi/features.ts": 93,
	"./hi/feedback": 94,
	"./hi/feedback.ts": 94,
	"./hi/general": 95,
	"./hi/general.ts": 95,
	"./hi/main": 96,
	"./hi/main.ts": 96,
	"./hi/menu": 97,
	"./hi/menu.ts": 97,
	"./hi/price": 98,
	"./hi/price.ts": 98,
	"./hi/roadmap": 99,
	"./hi/roadmap.ts": 99,
	"./it/build": 100,
	"./it/build.ts": 100,
	"./it/donate": 101,
	"./it/donate.ts": 101,
	"./it/downloads": 102,
	"./it/downloads.ts": 102,
	"./it/features": 103,
	"./it/features.ts": 103,
	"./it/feedback": 104,
	"./it/feedback.ts": 104,
	"./it/general": 105,
	"./it/general.ts": 105,
	"./it/main": 106,
	"./it/main.ts": 106,
	"./it/menu": 107,
	"./it/menu.ts": 107,
	"./it/price": 108,
	"./it/price.ts": 108,
	"./it/roadmap": 109,
	"./it/roadmap.ts": 109,
	"./ja/build": 110,
	"./ja/build.ts": 110,
	"./ja/donate": 111,
	"./ja/donate.ts": 111,
	"./ja/downloads": 112,
	"./ja/downloads.ts": 112,
	"./ja/features": 113,
	"./ja/features.ts": 113,
	"./ja/feedback": 114,
	"./ja/feedback.ts": 114,
	"./ja/general": 115,
	"./ja/general.ts": 115,
	"./ja/main": 116,
	"./ja/main.ts": 116,
	"./ja/menu": 117,
	"./ja/menu.ts": 117,
	"./ja/price": 118,
	"./ja/price.ts": 118,
	"./ja/roadmap": 119,
	"./ja/roadmap.ts": 119,
	"./ko/build": 120,
	"./ko/build.ts": 120,
	"./ko/donate": 121,
	"./ko/donate.ts": 121,
	"./ko/downloads": 122,
	"./ko/downloads.ts": 122,
	"./ko/features": 123,
	"./ko/features.ts": 123,
	"./ko/feedback": 124,
	"./ko/feedback.ts": 124,
	"./ko/general": 125,
	"./ko/general.ts": 125,
	"./ko/main": 126,
	"./ko/main.ts": 126,
	"./ko/menu": 127,
	"./ko/menu.ts": 127,
	"./ko/price": 128,
	"./ko/price.ts": 128,
	"./ko/roadmap": 129,
	"./ko/roadmap.ts": 129,
	"./language": 4,
	"./language.tsx": 4,
	"./pt/build": 130,
	"./pt/build.ts": 130,
	"./pt/donate": 131,
	"./pt/donate.ts": 131,
	"./pt/downloads": 132,
	"./pt/downloads.ts": 132,
	"./pt/features": 133,
	"./pt/features.ts": 133,
	"./pt/feedback": 134,
	"./pt/feedback.ts": 134,
	"./pt/general": 135,
	"./pt/general.ts": 135,
	"./pt/main": 136,
	"./pt/main.ts": 136,
	"./pt/menu": 137,
	"./pt/menu.ts": 137,
	"./pt/price": 138,
	"./pt/price.ts": 138,
	"./pt/roadmap": 139,
	"./pt/roadmap.ts": 139,
	"./ru/build": 140,
	"./ru/build.ts": 140,
	"./ru/donate": 141,
	"./ru/donate.ts": 141,
	"./ru/downloads": 142,
	"./ru/downloads.ts": 142,
	"./ru/features": 143,
	"./ru/features.ts": 143,
	"./ru/feedback": 144,
	"./ru/feedback.ts": 144,
	"./ru/general": 145,
	"./ru/general.ts": 145,
	"./ru/main": 146,
	"./ru/main.ts": 146,
	"./ru/menu": 147,
	"./ru/menu.ts": 147,
	"./ru/price": 148,
	"./ru/price.ts": 148,
	"./ru/roadmap": 149,
	"./ru/roadmap.ts": 149,
	"./zh/build": 150,
	"./zh/build.ts": 150,
	"./zh/donate": 151,
	"./zh/donate.ts": 151,
	"./zh/downloads": 152,
	"./zh/downloads.ts": 152,
	"./zh/features": 153,
	"./zh/features.ts": 153,
	"./zh/feedback": 154,
	"./zh/feedback.ts": 154,
	"./zh/general": 155,
	"./zh/general.ts": 155,
	"./zh/main": 156,
	"./zh/main.ts": 156,
	"./zh/menu": 157,
	"./zh/menu.ts": 157,
	"./zh/price": 158,
	"./zh/price.ts": 158,
	"./zh/roadmap": 159,
	"./zh/roadmap.ts": 159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 181;